import firebase from 'firebase'

let config = {
  apiKey: 'AIzaSyDg4Nhebf5Pzw_kgvsWyPVuLSCJBJlJdhs',
  authDomain: 'diensteapp.firebaseapp.com',
  databaseURL: 'https://diensteapp.firebaseio.com',
  projectId: 'diensteapp',
  storageBucket: '',
  messagingSenderId: '469820439777'
}

let app = firebase.initializeApp(config)
let db = app.database()

let googleProvider = new firebase.auth.GoogleAuthProvider()
googleProvider.addScope('https://www.googleapis.com/auth/contacts.readonly')

let facebookProvider = new firebase.auth.FacebookAuthProvider()
facebookProvider.addScope('email,public_profile')

export default {
  app,
  db,
  auth: app.auth(),
  servicesRef: db.ref('sevices'),
  daysRef: db.ref('days'),
  jobsRef: db.ref('jobs'),
  participantsRef: db.ref('participants'),
  usersRef: db.ref('users'),
  googleProvider,
  facebookProvider
}



// WEBPACK FOOTER //
// ./src/firebase.js